export const erpRoutes = {
  admin: {
    employees: {
      list: '/admin/employees',
      view: '/admin/employees/:id',
      version: '/admin/employees/:id/version',
      employeeProfile: '/admin/employees/profile',
    },
    documents: {
      list: '/admin/documents',
      listForEmployee: '/admin/employee-documents',
      folder: '/admin/documents/:id',
      folderForEmployee: '/admin/employee-documents/:id',
    },
    documentTemplates: {
      list: '/admin/documents?activeTab=1',
      new: '/admin/documents/templates/new',
      edit: '/admin/documents/templates/:id',
    },
    jobTitles: {
      list: '/admin/job-titles',
      new: '/admin/job-titles/new',
      edit: '/admin/job-titles/:id',
    },
    departments: {
      list: '/admin/departments',
      new: '/admin/departments/new',
      edit: '/admin/departments/:id',
    },
    tasks: {
      list: '/admin/tasks',
      view: '/admin/tasks/:id',
    },
    workTimes: {
      schedule: '/admin/work-times/schedule',
      scheduleForEmployee: '/admin/work-times/employee-schedule',
    },
    globalDocumentTemplates: {
      list: '/admin/global-document-templates',
      new: '/admin/global-document-templates/new',
      edit: '/admin/global-document-templates/:id',
    },
    globalProcessSettings: {
      list: '/admin/global-process-settings',
      new: '/admin/global-process-settings/new',
      edit: '/admin/global-process-settings/:id',
    },
    processSettings: {
      list: '/admin/processes?activeTab=1',
      new: '/admin/processes/settings/new',
      edit: '/admin/processes/settings/:id',
      editProcessSettingsTasks: '/admin/processes/settings/:id/?activeTab=1',
    },
    processes: {
      list: '/admin/processes',
      listByEmployee: '/admin/processes/employee',
      view: '/admin/processes/:id',
    },
  },
  auth: {},
};
